const multiMcc = ['234', '235', '310', '311', '312', '316', '404', '405'];
export default multiMcc;
